import { NcPage } from "@noted/noted-components";
import { Navigate, Route, Routes } from "react-router-dom";

import { FeaturePermission } from "~/api/graphql-types";
import { useAccount } from "~/components/account-context/account.context";
import { useFeatures } from "~/components/features.context";
import { SubNavigation } from "~/components/navigation/sub-navigation";
import { useI18n } from "~/hooks/use-i18n";

import { AccSettingsPage } from "./acc-settings-settings";
import { AssignedTeams } from "./assigned-teams";
import { UserDetails } from "./user-details";

export const UserSettings = () => {
  const { t } = useI18n("user-settings");
  const { account: user } = useAccount();
  const { featureEnabled } = useFeatures();
  const hasACC = featureEnabled(FeaturePermission.AccBilling);
  return (
    <NcPage variant="subNavigation">
      <SubNavigation variant="indirectDescendant">
        <SubNavigation.Link to="user-details">
          {t("user-settings:userDetails.title")}
        </SubNavigation.Link>
        {hasACC && (
          <SubNavigation.Link to="acc-settings">
            {t("user-settings:accSettings.title")}
          </SubNavigation.Link>
        )}
        <SubNavigation.Link to="assigned-teams">
          {t("user-settings:assignedTeams.title")}
        </SubNavigation.Link>
      </SubNavigation>

      <Routes>
        <Route path="user-details" element={<UserDetails user={user} />} />
        {hasACC && <Route path="acc-settings" element={<AccSettingsPage user={user} />} />}
        <Route path="assigned-teams" element={<AssignedTeams user={user} />} />
        <Route path="" element={<Navigate to="user-details" replace />} />
      </Routes>
    </NcPage>
  );
};
